<template>
    <transition name="fade">
        <div class="absolute inset-0 z-50 bg-black/30 rounded-2xl w-full flex justify-center items-center">

            <div class="w-11/12 lg:w-1/2 h-1/4 lg:h-1/3 bg-white rounded-xl flex flex-col ">
                <div class="bg-white h-3/4 w-5/6 mx-auto rounded-t-lg flex flex-col justify-center items-center">
                    <div class="text-gray-800 text-lg text-center">{{ $t('cancel_order_message') }}</div>
                    <div class="text-sm text-gray-400 font-medium mt-2">({{ $t('cancel_order_submessage') }})</div>
                </div>
                <div class="bg-slate-200 h-1/4  rounded-b-lg  ">
                    <div class="w-4/5 mx-auto flex justify-evenly items-center h-full">

                        <div @click="close"
                            class="bg-gray-400 text-xs lg:text-base text-white py-1 px-2 rounded hover:cursor-pointer  ">
                            {{
                                $t('close') }} </div>
                        <div @click="confirm"
                            class="bg-emerald-500 text-xs lg:text-base text-white py-1 px-2 rounded hover:cursor-pointer  ">
                            {{
                                $t('confirm_cancel_button') }}</div>
                    </div>
                </div>

            </div>
        </div>
    </transition>
</template>

<script setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['ConfirmCancel', 'CloseCancel']);


const confirm = () => {
    emit('ConfirmCancel');

}

const close = () => {
    emit('CloseCancel');

}
</script>
